import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import { Grid, Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import useStyles from "../../../../themes/style.js";
// import useRazorpay from "react-razorpay";
import concernIcon from "../../../../images/employee/concern.png";
import feedbackIcon from "../../../../images/employee/feedback.png";
import PageTitle from "../../../../components/PageTitle/PageTitle.js";

import ApprovalIcon from "../../../../images/employee/approval.png";
import DeclineIcon from "../../../../images/employee/decline.png";
import PendingIcon from "../../../../images/employee/pending.png";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "14px 0px" }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function EmployeeLeave() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const adminTitlePaths = ["yet-to-approve", "approve","decline"];

  const activeTabIndex = adminTitlePaths.findIndex((path) =>
    pathname.includes(path),
  );

  const queryParams = new URLSearchParams(location.search);
  const userIdParam = queryParams.get("user_id");
  const userNameParam = queryParams.get("user_name");

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={6}>
        <PageTitle title="Leave Management" />
      </Grid>
      <AppBar
        position="static"
        style={{
          background: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
          border: "2px solid #EEEEEE",
          borderRadius: "8px",
          boxShadow: "rgba(0, 0, 0, 0.04) 0px 3px 5px",
          zIndex: 1,
        }}
      >
        <Tabs
          value={activeTabIndex}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className={classes.instanceTabList}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#064be2",
              height: "2px",
              borderRadius: "8px",
              zIndex: 0,
            },
          }}
        >
          <Tab
            label={"Yet To Approve"}
            icon={
              <img
                src={PendingIcon}
                alt="feedback_icon"
                className={classes.appBarIconImages}
              />
            }
            onClick={() => history.push(`/app/employee/leave/yet-to-approve`)}
          />
          <Tab
            label={"Approved"}
            icon={
              <img
                src={ApprovalIcon}
                alt="concern_icon"
                className={classes.appBarIconImages}
              />
            }
            onClick={() => history.push(`/app/employee/leave/approve`)}
          />
          <Tab
            label={"Declined"}
            icon={
              <img
                src={DeclineIcon}
                alt="concern_icon"
                className={classes.appBarIconImages}
              />
            }
            onClick={() => history.push(`/app/employee/leave/decline`)}
          />
        </Tabs>
      </AppBar>
    </Grid>
  );
}
